import * as React from 'react';
import { browserHistory } from 'react-router';

import hoistNonReactStatic from 'hoist-non-react-statics';

export const stack: React.Component[] = [];

export function handleTransition(location: any) {
  // if location change is a replace action
  // then isn't not a page transtion we can ignore it.
  if (!location || location.action !== 'REPLACE') {
    let l = stack.length;
    while (l--) {
      const layer: React.Component<any> = stack[l];
      if (layer && layer.props.hideOnTransition) {
        if (layer.props.onRequestHide) {
          layer.props.onRequestHide();
        }
      }
    }
  }
}

if (browserHistory) {
  browserHistory.listen(handleTransition);
}

function withLayerHideOnTransitionTrigger(
  Child: React.ComponentType<any>
): React.ComponentType<any> {
  class LayerHideOnTransitionTrigger extends React.Component<any> {
    static defaultProps = {
      hideOnTransition: true,
    };
    // $FlowFixMe property `displayName` not found in Component object type
    displayName = `withLayerHideOnTransitionTrigger(${
      ((Child as unknown) as React.SFC).displayName
    })`;

    componentDidMount() {
      stack.push(this);
    }

    componentWillUnmount() {
      const index = stack.indexOf(this);
      if (index >= 0) {
        stack.splice(index, 1);
      }
    }

    render() {
      return <Child {...this.props} />;
    }
  }
  return hoistNonReactStatic(LayerHideOnTransitionTrigger, Child);
}

export default withLayerHideOnTransitionTrigger;
